/* Rieles: flechas que avanzan una pantalla entera y un hilo que muestra
   cuanto falta. Avanzar de a un cuadro obliga a doce clics para ver doce
   escudos; avanzar de a una pantalla son tres. */
(function () {
  "use strict";

  Array.prototype.forEach.call(document.querySelectorAll("[data-riel]"), function (riel) {
    var caja = riel.closest(".riel-caja") || riel.parentNode;
    var flechas = caja.querySelectorAll("[data-riel-ir]");
    var hilo = caja.querySelector(".riel-hilo");

    function maximo() { return riel.scrollWidth - riel.clientWidth; }

    function refrescar() {
      var max = maximo();
      var x = riel.scrollLeft;
      Array.prototype.forEach.call(flechas, function (f) {
        var d = Number(f.getAttribute("data-riel-ir"));
        f.disabled = max <= 1 || (d < 0 ? x <= 2 : x >= max - 2);
      });
      if (hilo && max > 1) {
        var parte = riel.clientWidth / riel.scrollWidth;
        hilo.style.width = Math.max(12, parte * 100) + "%";
        var corre = (x / max) * (100 - Math.max(12, parte * 100));
        hilo.style.transform = "translateX(" + (corre / Math.max(12, parte * 100)) * 100 + "%)";
      }
    }

    Array.prototype.forEach.call(flechas, function (f) {
      f.addEventListener("click", function () {
        var d = Number(f.getAttribute("data-riel-ir"));
        /* Se deja un cuadro de solape para no perder el hilo de donde
           venia la vista. */
        riel.scrollBy({ left: d * (riel.clientWidth * 0.92), behavior: "smooth" });
      });
    });

    var pendiente = false;
    riel.addEventListener("scroll", function () {
      if (pendiente) { return; }
      pendiente = true;
      requestAnimationFrame(function () { refrescar(); pendiente = false; });
    }, { passive: true });

    addEventListener("resize", refrescar, { passive: true });
    refrescar();
  });
})();
